import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF } from '../../../Layout/tokens';

export const DEFAULT_MAIN_PANELS: Record<string, TypedGroupviewPanelState> = {
  monitoringBlotters: {
    id: 'monitoringBlotters',
    contentComponent: 'monitoringBlotter',
    title: 'Blotters',
    params: { type: 'monitoringBlotter' },
  },
};

export const DEFAULT_PANELS: Record<string, TypedGroupviewPanelState> = {
  ...DEFAULT_MAIN_PANELS,
};

export const DEFAULT_GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: LEAF,
        visible: true,
        data: { views: ['monitoringBlotters'], activeView: 'monitoringBlotters', id: 'monitoringBlotters' },
        size: 1600,
      },
    ],
    size: 1600,
  },
  width: 1600,
  height: 900,
  orientation: Orientation.HORIZONTAL,
};

export const DEFAULT_MONITORING_LAYOUT: SerializedDockview = {
  grid: DEFAULT_GRID,
  panels: DEFAULT_PANELS,
};
